export const permissionsComparator = (a: { displayOrder: number }, b: { displayOrder: number }) => {
  return a.displayOrder - b.displayOrder;
};
